import Config from '../classes/Config'
import { CALL_API } from '../middleware/api'

/* Construct a query argument from the struct
 *
 */
export function queryArgString (struct) {
  let ret = []
  for (let d in struct) {
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(struct[d]))
  }
  let s = ret.join('&')
  if (s.length > 0) {
    return `?${s}`
  }
  return s
}

/**
 * Determines if the data is "stale" and we should refresh.
 * @param {number} lastUpdated Time this item was last updated.
 */
export function beforeCutoff (lastUpdated) {
  // null is an automatic true
  return (!lastUpdated || (lastUpdated < (Date.now() - Config.DataStalenessCutoffMs)))
}

/** Standard logic for whether or not you should fetch the data in question.
 *
 *  Expects an object with attributes:
 *  - isFetching - boolean indicating whether or not we are currently fetching data
 *  - didInvalidate - boolean indicating whether the local data has been invalidated and should be refreshed.
 *  - lastUpdated - Date indicating when the data was last fetched.
 */
export function shouldFetch (data) {
  if (!data) {
    return true // We haven't fetched this group yet.
  } else if (data.isFetching) {
    return false
  } else if (data.didInvalidate) {
    return true
  } else {
    return beforeCutoff(data.lastUpdated)
  }
}

/** Makes an authenticated get call
 */
export function makeApiCall (props) {
  const actionProps = props.actionProps || {}
  let attrs = {}
  if (props.actionProps) {
    attrs.actionAttrs = actionProps
  }
  if (props.method) {
    attrs.config = {
      method: props.method
    }
    if (props.body) {
      attrs.config.body = JSON.stringify(props.body)
    }
  }
  let authenticated = true
  if ('authenticated' in props) {
    authenticated = props.authenticated
  }

  return dispatch => {
    dispatch({
      ...actionProps,
      type: props.actionRequest
    })
    return dispatch({
      [CALL_API]: {
        endpoint: props.url,
        authenticated: authenticated,
        types: [props.actionReceive, props.actionFailure],
        ...attrs
      }
    })
  }
}
